import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import WidgetsRoundedIcon from '@mui/icons-material/WidgetsRounded';
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    TextField,
    Typography
} from "@mui/material";
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import { ThemeProvider } from "@mui/styles";
import dayjs from "dayjs";
import { QRCodeSVG } from 'qrcode.react';
import React, { Component } from "react";
import NumberFormat from "react-number-format";
import { QrReader } from 'react-qr-reader';
import { Link } from "react-router-dom";
import CircularLoading from "../components/CircularLoading";
import { GetAddressLine2 } from "../services/Address";
import { GetProduct } from '../services/Product';
import { GetRole, GuestLogin, Me, SetToken, SetUser, UpdateToken } from "../services/Session";
import { DeleteOrderById, GetOrderById, GetOrderHistories, GetOrderWaybill, UpdateOrderById, UpdateOrderWaybill } from "../services/Transaction";
import "../styles/style.css";
import theme from "../styles/theme";
import { OrderStatus } from '../utils/Validation';

const BackIcon = "/assets/svg/back.svg";

class TransactionDetail extends Component {
	constructor(props) {
		super(props);

		this.state = {
			order: "",
			order_history: [],
			catalog_product_id: '',
			modalUpdateOpen: false,
			modalCancelOpen: false,
			modalScanBarcodeOpen: false,
			update_data: {
				status: '',
				payment: {}
			},
			loading: false,
		}
	}

	componentDidMount = () => {
		this.handleGetOrder();
	}

	handleGetOrder = () => {
		this.setState({ loading: true });
		GetOrderById(this.props.match.params.id)
			.then(res => {
				this.setState({ order: res.data });
				this.handleGetProducts(res.data.line_items[0].product.id)
				this.handleGetHistories(res.data.id)
				this.handleGetWaybill(res.data.id)
				this.setState({ loading: false });
			})
			.catch(err => {
				this.setState({ loading: false });
				if (err.response) {
					if (err.response && err.response.status === 401) {
						this.setState({ attempt: this.state.attempt + 1 });
						if (this.state.attempt < 10) {
							UpdateToken().then(res => {
								Me(SetToken(res.data.token).access_token).then(res => {
									SetUser(res.data);
									setTimeout(this.handleGetOrder(), 5000);
								});
							});
						} else {
							this.handleLogout();
						}
					}
				}
			})
	}

	handleGetProducts = (prod_id) => {
		this.setState({ loading: true });
		GetProduct({ 'id': prod_id })
			.then(res => {
				if (res.data.results.length > 0) {
					this.setState({ catalog_product_id: res.data.results[0].catalog.code });
				}
			})
			.catch(err => {
				this.setState({ loading: false });
				if (err.response) {
					if (err.response && err.response.status === 401) {
						this.setState({ attempt: this.state.attempt + 1 });
						if (this.state.attempt < 10) {
							UpdateToken().then(res => {
								Me(SetToken(res.data.token).access_token).then(res => {
									SetUser(res.data);
									setTimeout(this.handleGetProducts(), 5000);
								});
							});
						} else {
							this.handleLogout();
						}
					}
				}
			})
	}

	handleGetHistories = (order_id) => {
		this.setState({ loading: true });
		GetOrderHistories(order_id)
			.then(res => {
				if (res.data.results.length > 0) {
					this.setState({ order_history: res.data.results });
				}
			})
			.catch(err => {
				this.setState({ loading: false });
				if (err.response) {
					if (err.response && err.response.status === 401) {
						this.setState({ attempt: this.state.attempt + 1 });
						if (this.state.attempt < 10) {
							UpdateToken().then(res => {
								Me(SetToken(res.data.token).access_token).then(res => {
									SetUser(res.data);
									setTimeout(this.handleGetHistories(), 5000);
								});
							});
						} else {
							this.handleLogout();
						}
					}
				}
			})
	}

	handleGetWaybill = (order_id) => {
		GetOrderWaybill(order_id)
			.then(res => {
				if (res.data.manifests) {
					this.setState({ waybill_number: res.data.number, delivery_tracking: res.data.manifests });
				}
			})
			.catch(err => {
				if (err.response) {
					if (err.response && err.response.status === 401) {
						this.setState({ attempt: this.state.attempt + 1 });
						if (this.state.attempt < 10) {
							UpdateToken().then(res => {
								Me(SetToken(res.data.token).access_token).then(res => {
									SetUser(res.data);
									setTimeout(this.handleGetWaybill(), 5000);
								});
							});
						} else {
							this.handleLogout();
						}
					}
				}
			})
	}

	handleSaveWaybill = (order_id) => {
		this.setState({ loading: true });
		UpdateOrderWaybill(order_id, { number: this.state.waybill_number })
			.then(res => {
				if (res.data.manifests) {
					this.setState({ waybill_number: res.data.number, delivery_tracking: res.data.manifests });
				}
				GetOrderById(order_id).then(o => { this.setState({ order: o.data }) })
				this.setState({ loading: false })
				alert('Nomor Resi berhasil disimpan')
			})
			.catch(err => {
				alert('Nomor Resi gagal disimpan')
				if (err.response) {
					if (err.response && err.response.status === 401) {
						this.setState({ attempt: this.state.attempt + 1 });
						if (this.state.attempt < 10) {
							UpdateToken().then(res => {
								Me(SetToken(res.data.token).access_token).then(res => {
									SetUser(res.data);
									setTimeout(this.handleSaveWaybill(order_id), 5000);
								});
							});
						} else {
							this.handleLogout();
						}
					}
				}
				this.setState({ loading: false });
			})
	}

	handleUpdateOrder = (order_id) => {
		const { update_data } = this.state
		if (update_data.status !== 'delivered' && (update_data.payment.amount === undefined || update_data.payment.amount <= 0)) {
			alert('Jumlah dibayar tidak boleh nol')
		} else {
			this.setState({ loading: true });
			UpdateOrderById(order_id, this.state.update_data)
				.then(res => {
					this.setState({ order: res.data, loading: false });
					this.toggleModalUpdate()
				})
				.catch(err => {
					this.setState({ loading: false });
					if (err.response) {
						if (err.response && err.response.status === 401) {
							this.setState({ attempt: this.state.attempt + 1 });
							if (this.state.attempt < 10) {
								UpdateToken().then(res => {
									Me(SetToken(res.data.token).access_token).then(res => {
										SetUser(res.data);
										setTimeout(this.handleUpdateOrder(order_id), 5000);
									});
								});
							} else {
								this.handleLogout();
							}
						}
					}
				})
		}
	}

	handleReceiveOrder = (order_id) => {
		this.setState({ loading: true });
		UpdateOrderById(order_id, { status: 'delivered' })
			.then(res => {
				this.setState({ order: res.data, loading: false });
			})
			.catch(err => {
				this.setState({ loading: false });
				if (err.response) {
					if (err.response && err.response.status === 401) {
						this.setState({ attempt: this.state.attempt + 1 });
						if (this.state.attempt < 10) {
							UpdateToken().then(res => {
								Me(SetToken(res.data.token).access_token).then(res => {
									SetUser(res.data);
									setTimeout(this.handleReceiveOrder(order_id), 5000);
								});
							});
						} else {
							this.handleLogout();
						}
					}
				}
			})
	}

	handlePackingOrder = (order_id) => {
		this.setState({ loading: true });
		UpdateOrderById(order_id, { status: 'packing' })
			.then(res => {
				this.setState({ order: res.data, loading: false });
			})
			.catch(err => {
				this.setState({ loading: false });
				if (err.response) {
					if (err.response && err.response.status === 401) {
						this.setState({ attempt: this.state.attempt + 1 });
						if (this.state.attempt < 10) {
							UpdateToken().then(res => {
								Me(SetToken(res.data.token).access_token).then(res => {
									SetUser(res.data);
									setTimeout(this.handlePackingOrder(order_id), 5000);
								});
							});
						} else {
							this.handleLogout();
						}
					}
				}
			})
	}

	handleDeleteOrder = (order_id) => {
		this.setState({ loading: true });
		DeleteOrderById(order_id)
			.then(res => {
				this.setState({ order: res.data, loading: false });
				this.toggleModalCancel()
			})
			.catch(err => {
				this.setState({ loading: false });
				if (err.response) {
					if (err.response && err.response.status === 401) {
						this.setState({ attempt: this.state.attempt + 1 });
						if (this.state.attempt < 10) {
							UpdateToken().then(res => {
								Me(SetToken(res.data.token).access_token).then(res => {
									SetUser(res.data);
									setTimeout(this.handleDeleteOrder(order_id), 5000);
								});
							});
						} else {
							this.handleLogout();
						}
					}
				}
			})
	}

	toggleModalUpdate = () => {
		const { modalUpdateOpen } = this.state
		this.setState({ modalUpdateOpen: !modalUpdateOpen })
	}

	toggleModalCancel = () => {
		const { modalCancelOpen } = this.state
		this.setState({ modalCancelOpen: !modalCancelOpen })
	}

	handleLogout = () => {
		GuestLogin().then(res => {
			Me(SetToken(res.data.token).access_token).then(res => {
				SetUser(res.data);
				setTimeout(this.props.history.push("/"), 3000);
			})
		})
	}

	modalCancelOrder = () => {
		const { order } = this.state
		return (
			<Dialog open={this.state.modalCancelOpen} onClose={this.toggleModalCancel} aria-labelledby="form-dialog-title">
				<DialogTitle id="form-dialog-title">Konfirmasi</DialogTitle>
				<DialogContent>
					<DialogContentText>Antum yakin ingin membatalkan pesanan ini?</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button variant="outlined" onClick={this.toggleModalCancel} color="secondary">Tidak</Button>
					<Button variant="contained" onClick={() => this.handleDeleteOrder(order.id)} color="secondary">Ya</Button>
				</DialogActions>
			</Dialog>
		)
	}

	modalUpdateOrder = () => {
		const { order } = this.state
		return (
			<Dialog open={this.state.modalUpdateOpen} onClose={this.toggleModalUpdate} aria-labelledby="form-dialog-title">
				<DialogTitle id="form-dialog-title">Konfirmasi Pembayaran</DialogTitle>
				<DialogContent>
					<TextField
						label="Dibayar pada"
						type="datetime-local"
						defaultValue={this.state.update_data.payment.paid_at}
						onChange={(opt) => this.handleChangeText(opt, 'paid_at')}
						size="small"
						variant="outlined"
						style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 10 }}
						InputLabelProps={{
							shrink: true,
						}}
					/>
					<TextField
						label="Jumlah Dibayar"
						type="number"
						defaultValue={this.state.update_data.payment.amount || 0}
						onChange={(opt) => this.handleChangeText(opt, 'amount')}
						size="small"
						variant="outlined"
						style={{ height: 40, width: 240, paddingTop: 0, paddingBottom: 10 }}
						InputLabelProps={{
							shrink: true,
						}}
					/>
				</DialogContent>
				<DialogActions>
					<Button variant="outlined" onClick={this.toggleModalUpdate} color="primary">Batal</Button>
					<Button variant="contained" onClick={() => this.handleUpdateOrder(order.id)} color="primary">Simpan</Button>
				</DialogActions>
			</Dialog>
		)
	}

	modalScanBarcode = () => {
		return (
			<Dialog fullWidth open={this.state.modalScanBarcodeOpen} onClose={() => this.setState({ modalScanBarcodeOpen: false })} aria-labelledby="form-dialog-title">
				<DialogTitle id="form-dialog-title">Scan Barcode</DialogTitle>
				<QrReader
					constraints={{
						facingMode: 'environment'
					}}
					onResult={(result, error) => {
						if (result) this.setState({ waybill_number: result.getText(), modalScanBarcodeOpen: false })
					}}
				/>
				<DialogActions>
					<Button variant="contained" onClick={() => this.setState({ modalScanBarcodeOpen: false })} color="primary">Batal</Button>
				</DialogActions>
			</Dialog>
		)
	}

	handleChangeText = (data, filtername) => {
		if (filtername !== 'paid_at' && filtername !== 'amount') {
			this.setState({ [filtername]: data.target.value })
		} else {
			const { update_data } = this.state
			let paid_at = (filtername === 'paid_at') ? data.target.value : update_data.payment.paid_at
			let amount = (filtername === 'amount') ? data.target.value : update_data.payment.amount
			this.setState({
				update_data: {
					status: 'paid',
					payment: {
						paid_at: dayjs(paid_at).format(),
						amount: parseFloat(amount) || 0,
					}
				}
			})
		}
	}

	nextLink = (paymentId) => {
		const { order } = this.state
		let next_link = ''
		let next_state = ''
		if (order.status === 'awaiting_payment') {
			next_link = `/pembayaran/${paymentId}`
			next_state = { order_detail: order }
		} else if (order.status === 'delivered') {
			next_link = `/produk/${this.state.catalog_product_id}`
			next_state = {}
		} else if (order.type === 'ticket' && order.status === 'paid') {
			next_link = `/transaksi/${order.number}/tiket`
			next_state = {}
		} else {
			next_link = '/transaksi/'
			next_state = {}
		}

		this.props.history.push({
			pathname: next_link,
			state: next_state
		});
	}

	wordingButton = () => {
		const { order } = this.state
		if (order.type === 'ticket' && order.status === 'paid') {
			return 'Lihat Tiket'
		} else if (order.status === 'delivered') {
			return 'Beli Lagi'
		} else if (order.status === 'awaiting_payment') {
			return 'Bayar'
		} else if (order.status === 'shipped') {
			return 'Barang Diterima'
		} else {
			return 'OK'
		}
	}

	wordingStatus = (status) => {
		if (status === 'created') {
			return 'Dibuat';
		} else if (status === 'awaiting_payment') {
			return 'Menunggu Pembayaran';
		} else if (status === 'paid') {
			return 'Lunas';
		} else if (status === 'expired') {
			return 'Kedaluwarsa';
		} else if (status === 'canceled') {
			return 'Dibatalkan';
		} else if (status === 'rejected') {
			return 'Ditolak';
		} else if (status === 'refunded') {
			return 'Dikembalikan';
		} else if (status === 'packing') {
			return 'Diproses';
		} else if (status === 'shipped') {
			return 'Dikirim';
		} else if (status === 'delivered') {
			return 'Sampai Tujuan';
		}
	}

	render() {
		const bank_charge = 0
		const { order, order_history, waybill_number, delivery_tracking, loading } = this.state
		let phone = (order.customer !== undefined && order.customer.phone !== undefined) ? order.customer.phone : ''
		let wa_url = (GetRole().id > 2) ? "https://wa.me/" + phone + "?text=" : "/callback/contact_rotators/kontak?text="
		let awaitingPaymentVirtualAccountScreen = () => {
			if (order) {
				return (
					<div className="wrapper" style={{ paddingBottom: 100 }}>
						<div className="order-card" style={{ borderRadius: 0, textAlign: "left", height: "auto", fontSize: "12px", color: "#666", width: 320, display: "block", margin: "0 auto" }} >
							<div style={{ margin: 'auto', textAlign: 'center', paddingTop: 20 }}>
								<QRCodeSVG
									value={order.number}
									size={128}
									bgColor={"#ffffff"}
									fgColor={"#000000"}
									level={"L"}
									includeMargin={false}
									imageSettings={{
										src: "/assets/images/logo-pernik-hsi.png",
										height: 30,
										width: 42,
										excavate: true,
									}}
								/>
							</div>
							<div style={{ padding: 10, fontSize: 14 }}>
								<div style={{ marginBottom: '4px' }}>
									<b>Status:</b>
									<span style={{ float: "right" }}>
										<b>{OrderStatus[order.status]}</b>
									</span>
								</div>
								<div style={{ marginBottom: '4px' }}>
									<b>Nomor Transaksi: </b>
									<span style={{ float: "right" }}>
										{order.number}
									</span>
								</div>
								<div style={{ marginBottom: '4px' }}>
									<b>Tanggal Transaksi: </b>
									<span style={{ float: "right" }}>
										{dayjs(order.created_at).format(
											"D MMM YYYY [Pukul] HH:mm"
										)}
									</span>
								</div>
								<hr />
								<div style={{ marginBottom: '4px' }}><b>Rincian:</b></div>
								{order.line_items.map((item, idx) => {
									let certificate = item.certificate ? JSON.parse(item.certificate) : undefined
									return <Grid container spacing={2} key={idx} className="rincian-item">
										<div style={{ paddingLeft: 15, paddingTop: 10, paddingBottom: 10 }}>
											<img alt="produk" src={item.product.image.url} style={{ width: 50 }} />
										</div>
										<div style={{ paddingLeft: 5, paddingTop: 10, paddingBottom: 10, width: 235 }}>
											<div><b>{item.product.name}</b></div>
											{certificate !== undefined &&
												<div>
													{certificate.number !== undefined && (<div>No : {certificate.number}</div>)}
													{certificate.nip !== undefined && (<div>NIP : {certificate.nip}</div>)}
													{certificate.name !== undefined && (<div>Nama : {certificate.name}</div>)}
												</div>
											}
											{(order.type == 'pre_order_internal') && (
												<div>Divisi : {item.note}</div>
											)}
											{(item.note != '' && order.type != 'pre_order_internal') && (
												<div><i>{item.note}</i></div>
											)}
											<div>{item.quantity} Pcs x <NumberFormat
												fixedDecimalScale decimalScale={0}
												value={item.unit_price}
												displayType={"text"}
												thousandSeparator={"."}
												decimalSeparator={","}
												prefix={"Rp "}
											/> = <NumberFormat
													fixedDecimalScale decimalScale={0}
													value={item.quantity * item.unit_price}
													displayType={"text"}
													thousandSeparator={"."}
													decimalSeparator={","}
													prefix={"Rp "}
												/></div>
											<hr />
										</div>
									</Grid>
								})}
								{(order.referral_code && order.referral_code !== '') && (
									<div style={{ marginBottom: 4, paddingLeft: 10 }}>Kode Referral:<span style={{ float: "right" }}>{order.referral_code}</span></div>
								)}
								{(order.voucher_code && order.voucher_code !== '') && (
									<div style={{ marginBottom: 4, paddingLeft: 10 }}>Kode Voucher:<span style={{ float: "right" }}>{order.voucher_code}</span></div>
								)}
								{(order.type != 'ticket') && (
									<div>
										<div style={{ marginBottom: 4, paddingLeft: 10 }}>
											Subtotal:
											<span style={{ float: "right" }}>
												<NumberFormat
													fixedDecimalScale decimalScale={0}
													value={order.subtotal ? order.subtotal : order.amount - order.delivery_service?.cost}
													displayType={"text"}
													thousandSeparator={"."}
													decimalSeparator={","}
													prefix={"Rp "}
												/>
											</span>
										</div>
										<div style={{ marginBottom: 4, paddingLeft: 10 }}>
											Biaya packing & pengiriman:
											<span style={{ float: "right" }}>
												<NumberFormat
													fixedDecimalScale decimalScale={0}
													value={order.delivery_service?.cost ?? 0}
													displayType={"text"}
													thousandSeparator={"."}
													decimalSeparator={","}
													prefix={"Rp "}
												/>
											</span>
										</div>
									</div>
								)}
								{order.discount ? (
									<div style={{ marginBottom: 4, paddingLeft: 10 }}>
										Diskon:
										<span style={{ float: "right" }}>
											<NumberFormat
												fixedDecimalScale decimalScale={0}
												value={order.discount}
												displayType={"text"}
												thousandSeparator={"."}
												decimalSeparator={","}
												prefix={"-Rp "}
											/>
										</span>
									</div>
								) : (<div></div>)}
								{bank_charge ? (
									<div style={{ marginBottom: 4, paddingLeft: 10 }}>
										Admin Bank:
										<span style={{ float: "right" }}>
											<NumberFormat
												fixedDecimalScale decimalScale={0}
												value={bank_charge}
												displayType={"text"}
												thousandSeparator={"."}
												decimalSeparator={","}
												prefix={"Rp "}
											/>
										</span>
									</div>
								) : (<div></div>)}
								<div style={{ marginBottom: 4, paddingLeft: 10 }}>
									Jumlah yang harus dibayar:
									<span style={{ color: "#00bfe6", float: "right" }}>
										<NumberFormat
											fixedDecimalScale decimalScale={0}
											value={order.amount + bank_charge}
											displayType={"text"}
											thousandSeparator={"."}
											decimalSeparator={","}
											prefix={"Rp "}
										/>
									</span>
								</div>
								<hr />
								{(order.type != 'ticket') && (<div><b>Alamat pengiriman:</b></div>)}
								{(order.delivery_service) && (
									<div style={{ fontSize: 12, paddingLeft: 10 }}>
										<div><b>{order.delivery_service.destination_address.contact_person}</b></div>
										<div>{order.delivery_service.destination_address.complete}</div>
										<div>{GetAddressLine2(order.delivery_service.destination_address)}</div>
										<div>Nomor HP : {order.delivery_service.destination_address.phone}</div>
									</div>
								)}
								{(order.type != 'ticket') && (
									<div>
										<hr />
										<div><b>Jasa Pengiriman:</b></div>
										<div style={{ paddingLeft: 10 }}>
											Kurir: {order.delivery_service?.courier_service?.name}
											{(waybill_number) && (
												<div>Nomor Resi : {waybill_number}</div>
											)}
										</div>
										<hr />
									</div>
								)}
								<div><b>Riwayat Transaksi:</b></div>
								{order_history.map((item, idx) => {
									return <div key={idx} kestyle={{ marginBottom: '4px' }}>- {this.wordingStatus(item.status)}<span style={{ float: "right" }}>{dayjs(item.created_at).format("D MMM YYYY [Pukul] HH:mm")}</span></div>
								})}
								{delivery_tracking && (
									<div>
										<hr />
										<b>Riwayat Pengiriman:</b>
									</div>
								)}
								{((order.type !== 'ticket') && (order.status === 'paid' || order.status === 'packing' || order.status === 'shipped' || order.status === 'delivered')) && (
									<div>
										{delivery_tracking && delivery_tracking.map((item, idx) => {
											return <div key={idx} style={{ padding: '8px 0' }}>- {item.description} {item.city}<br /><i>{dayjs(item.date).format("D MMM YYYY")} Pukul {item.time}</i></div>
										})}
									</div>
								)}
								{((order.type == 'pre_order' || order.type == 'pre_order_internal') && (order.status === 'paid' || order.status === 'packing' || order.status === 'shipped' || order.status === 'delivered')) && (
									<div>
										<div style={{ marginBottom: '4px' }}>- Menunggu Produksi<br /><i>{dayjs(order.payment.paid_at).format("D MMM YYYY [Pukul] HH:mm:ss")}</i></div>
										<br />
										<div><i>* Untuk produk Pre Order (PO), pesanan akan dikirim setelah barang selesai diproduksi, dengan estimasi produksi sekitar 2 bulan.</i></div>
									</div>
								)}
								<div style={{ padding: 60 }}></div>
							</div>
						</div>
					</div>
				);
			} else {
				return <div className="wrapper">
					<CircularProgress />
				</div>
			}
		};

		return (
			<ThemeProvider theme={theme}>
				<div style={{ position: 'relative', maxWidth: '60rem', margin: 'auto' }}>
				<div className="header">
					<Link
						to="/transaksi"
						style={{
							position: "absolute",
							height: 60,
							width: 60,
							top: 0,
							left: 0
						}}
					>
						<img alt="icon" src={BackIcon} />
					</Link>
					<div className="center">
						<h3 className="title">Rincian Transaksi</h3>
					</div>
					{
						order.status === 'awaiting_payment' &&
						<Button
							onClick={() => this.setState({ modalCancelOpen: true })}
							className="title"
							style={{ textTransform: 'none', position: 'absolute', height: 60, width: 60, top: 2, right: 20, color: 'red', fontWeight: 'normal' }}>
							Batalkan
						</Button>
					}
					{this.modalCancelOrder()}
				</div>
				{loading ? <CircularLoading /> :
					awaitingPaymentVirtualAccountScreen()
				}
				{this.modalUpdateOrder()}
				{this.modalScanBarcode()}
				{(GetRole().id > 2 && order.type !== 'ticket' && ['paid', 'packing', 'shipped'].includes(order.status)) ? (
					<>
						<div style={{ textAlign: "center", position: 'fixed', bottom: 60, right: 0, left: 0, background: "#fff", padding: 10 }}>
							<Button onClick={() => this.props.history.push("/lembar-pengiriman/" + this.props.match.params.id)} variant="contained" color="primary" style={{ textTransform: "none", height: 40, marginRight: 10 }} startIcon={<LocalShippingIcon />}>
								Lembar Pengiriman
							</Button>
							<Button onClick={() => this.handlePackingOrder(order.id)} variant="contained" color="primary" style={{ textTransform: "none", height: 40, width: 180 }} startIcon={<WidgetsRoundedIcon />}>
								{loading ? (<CircularLoading size={20} />) : (<Typography>Proses</Typography>)}
							</Button>
						</div>
						<div style={{ textAlign: "center", position: 'fixed', bottom: 0, right: 0, left: 0, background: "#fff", paddingTop: 10 }}>
							<TextField
								autoFocus
								label="Nomor Resi"
								type="text"
								value={this.state.waybill_number || ''}
								onChange={(opt) => this.handleChangeText(opt, 'waybill_number')}
								size="small"
								variant="outlined"
								style={{ height: 40, width: 280, paddingTop: 0, paddingBottom: 10, paddingRight: 10 }}
								InputProps={{
									endAdornment:
										<InputAdornment position="end">
											<IconButton aria-label="Scan Barcode" size="small" style={{ marginRight: -10 }} onClick={() => this.setState({ modalScanBarcodeOpen: true })}>
												<PhotoCamera />
											</IconButton>
										</InputAdornment>
								}}
							/>
							<Button onClick={() => this.handleSaveWaybill(order.id)} variant="contained" color="primary" style={{ textTransform: "none", height: 40 }} startIcon={<LocalShippingIcon />}>
								{loading ? (<CircularLoading size={20} />) : (<Typography>Simpan</Typography>)}
							</Button>
						</div>
					</>
				) : (
					<div style={{ textAlign: "center", position: 'fixed', bottom: 0, right: 0, left: 0, background: "#fff", padding: 10 }}>
						<a
							target="_blank"
							rel="noopener noreferrer"
							href={wa_url + encodeURI("Assalamu'alaykum\nAna mau tanya ini " + window.location.href + "/" + this.props.match.params.id)}
							style={{ textDecoration: "none", paddingRight: 10 }}
						>
							<Button variant="contained" color="primary" style={{ textTransform: "none", height: 40, width: 100 }} startIcon={<WhatsAppIcon />}>
								Chat
							</Button>
						</a>
						{(GetRole().id === 2 && (order.status === 'shipped')) && (
							<Button onClick={() => { this.handleReceiveOrder(order.id) }} variant="contained" color="primary" style={{ textTransform: "none", height: 40, width: 180 }}>
								Barang Diterima
							</Button>
						)}
						{(GetRole().id > 2 && order.type === 'ready_stock' && order.status === 'paid') && (
							<Button onClick={() => this.handlePackingOrder(order.id)} variant="contained" color="primary" style={{ textTransform: "none", height: 40, width: 180 }} startIcon={<WidgetsRoundedIcon />}>
								{loading ? (<CircularLoading size={20} />) : (<Typography>Proses</Typography>)}
							</Button>
						)}
						{(!(GetRole().id === 2 && order.status === 'shipped') 
							&& !((order.type === 'ticket' 
								|| order.type === 'pre_order' 
								|| order.type === 'pre_order_member' 
								|| order.type === 'pre_order_internal') && (order.status === 'shipped' || order.status === 'delivered')
							)
							&& !(GetRole().id > 2 
								&& order.type !== 'ticket' 
								&& order.type !== 'pre_order' 
								&& order.type !== 'pre_order_member' 
								&& order.type !== 'pre_order_internal' 
								&& (order.status === 'paid' || order.status === 'packing' || order.status === 'shipped' || order.status === 'delivered')
							)
						) && (
								<span href="#" style={{ textDecoration: "none" }} onClick={() => {
									if (order?.payment?.url !== undefined) {
										window.location.href = 'https://' + order?.payment?.url;
									} else {
										this.nextLink(order.number)
									}
								}}>
									<Button variant="contained" color="primary" style={{ textTransform: "none", height: 40, width: 180 }}>
										{this.wordingButton()}
									</Button>
								</span>
							)}
						{(GetRole().id > 2 && (order.status === 'awaiting_payment' || order.status === 'expired')) && (
							<IconButton color="primary" aria-label="konfirmasi pembayaran" onClick={() => this.setState({ modalUpdateOpen: true })}>
								<AttachMoneyIcon />
							</IconButton>
						)}
					</div>
				)}
				</div>
			</ThemeProvider>
		);
	}
}

export default TransactionDetail;
